var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrinter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 82.316 20.766 H 69.021 V 7.764 c 0 -2.664 -2.167 -4.831 -4.831 -4.831 H 25.811 c -2.664 0 -4.831 2.167 -4.831 4.831 v 13.002 H 7.683 C 3.447 20.766 0 24.213 0 28.449 v 34.511 c 0 4.236 3.447 7.683 7.683 7.683 h 13.296 v 11.593 c 0 2.664 2.167 4.831 4.831 4.831 h 38.379 c 2.664 0 4.831 -2.167 4.831 -4.831 V 70.643 h 13.296 c 4.236 0 7.684 -3.446 7.684 -7.683 V 28.449 C 90 24.213 86.553 20.766 82.316 20.766 z M 22.979 7.764 c 0 -1.561 1.27 -2.831 2.831 -2.831 h 38.379 c 1.562 0 2.831 1.27 2.831 2.831 v 13.002 H 22.979 V 7.764 z M 67.021 82.236 c 0 1.562 -1.27 2.831 -2.831 2.831 H 25.811 c -1.561 0 -2.831 -1.27 -2.831 -2.831 V 55.953 h 44.041 V 82.236 z M 67 30.628 c -0.828 0 -1.5 -0.672 -1.5 -1.5 s 0.672 -1.5 1.5 -1.5 s 1.5 0.672 1.5 1.5 S 67.828 30.628 67 30.628 z M 74 30.628 c -0.828 0 -1.5 -0.672 -1.5 -1.5 s 0.672 -1.5 1.5 -1.5 s 1.5 0.672 1.5 1.5 S 74.828 30.628 74 30.628 z M 81 30.628 c -0.828 0 -1.5 -0.672 -1.5 -1.5 s 0.672 -1.5 1.5 -1.5 s 1.5 0.672 1.5 1.5 S 81.828 30.628 81 30.628 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#231665",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 59.705 65.953 h -30 c -0.552 0 -1 -0.447 -1 -1 s 0.448 -1 1 -1 h 30 c 0.553 0 1 0.447 1 1 S 60.258 65.953 59.705 65.953 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#231665",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 59.705 75.953 h -30 c -0.552 0 -1 -0.447 -1 -1 s 0.448 -1 1 -1 h 30 c 0.553 0 1 0.447 1 1 S 60.258 75.953 59.705 75.953 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#231665",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinter);
export default __webpack_public_path__ + "static/media/printer.9d9cd04acdb9dac54c4ac2c3e03bb554.svg";
export { ForwardRef as ReactComponent };